<!--
 * @Author: WGL
 * @Date: 2023-06-19 09:06:21
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-02 15:26:47
 * @Description: 
-->
<template>
  <jwt-detail-drawer
    ref="pageDetailRef"
    :config="drawerConfig"
    :current-page-drawer-config="currentPageDrawerConfig"
    :current-page-path="currentPagePath"
    :keep-alive="false"
    :open-page-drawer-config-list="openPageDrawerConfigList"
    :user-menus-auth="userMenusAuthObj"
    @add-success="handleAddSuccess"
    @back-drawer="handleBackDrawer"
    @change="handleEditRowProp"
    @click-cell="handleClickRow"
    @close-drawer="handleCloseDrawer"
    @delete-success="handleDeleteSuccess"
    @des-edit-success="handleDesEditSuccess"
    @drawer-add-success="handleDrawerAddSuccess"
    @edit-success="handleEditSuccess"
    @footer-action="handleFooterAction"
    @header-action="handleHeaderAction"
    @push-drawer="handlePushDrawerList"
    @refresh-table="handleRefreshTable"
    @tab-click="handleTabClick"
  >
    <template
      v-for="k in Object.keys(slots)"
      #[k]="{ scope, model, row }"
      :key="k"
    >
      <slot :model="model" :name="k" :row="row" :scope="scope"></slot>
    </template>
  </jwt-detail-drawer>
</template>

<script>
  import {
    defineComponent,
    onBeforeMount,
    computed,
    useSlots,
    toRaw,
    ref,
    nextTick,
    onBeforeUnmount,
    watchEffect,
  } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter, useRoute } from 'vue-router'
  import { merge } from 'lodash-es'

  export default defineComponent({
    name: 'PageDetailDrawer',
    components: {
      // AppForm,
    },
    props: {
      config: { require: true, type: Object, default: () => {} }, // 页面结构配置
      refComponmentUrl: { type: String, default: '' },
      currentPageDrawerConfig: { type: Object, default: () => {} }, // 当前页面draw的打开配置
      drawerName: { type: String, default: 'defaultDrawer' }, // 当前页面draw的打开配置
    },
    emits: [
      'change',
      'click-cell',
      'header-action',
      'footer-action',
      'delete-success',
      'des-edit-success',
      'drawer-add-success',
    ],
    setup(props, { emit }) {
      const pageDetailRef = ref(null)
      const store = useStore()
      const route = useRoute()
      const router = useRouter()
      const slots = useSlots()
      const userMenusAuthObj = computed(() => store.getters['routes/menusObj'])
      // tab 新开页面
      const tabOpenBlankMode = computed(
        () => store.getters['sys/tabOpenBlankMode']
      )
      // 当前页面路径
      const currentPagePath = computed(() => {
        const { path: currentPath } = route
        let reult = props?.refComponmentUrl || currentPath || ''
        return reult || ''
      })
      // 动态组件的实例
      const currentTabsInstance = computed(() => {
        return pageDetailRef.value.dynamicsTabsInstance || null
      })
      // 打开的弹窗数据list
      const openPageDrawerConfigList = computed(
        () => store.getters['sys/openPageDrawerConfigList']
      )
      // 刷新抽屉弹窗详情
      const refreshDrawerDetail = computed(
        () => store.getters['sys/refreshDrawerDetail']
      )
      const drawerConfig = computed(() => {
        const { query } = route || {}
        const result = merge(props.config, {
          activeName: query?.tabname || props?.config?.activeName || '',
        })
        return result
      })
      const handleEditRowProp = (row, item) => {
        emit('change', row, item, 'drawDes')
      }

      const handleClickRow = (row, item) => {
        emit('click-cell', row, item)
      }

      const handleHeaderAction = (action) => {
        emit('header-action', action)
      }

      const handleFooterAction = (action, model) => {
        emit('footer-action', action, model)
      }

      const handleDesEditSuccess = (item) => {
        emit('des-edit-success', item)
      }

      /**
       * 弹窗添加成功
       * @param {*} data
       */
      const handleDrawerAddSuccess = (data) => {
        emit('drawer-add-success', data)
      }
      /**
       * 关闭弹窗
       */
      const handleCloseDrawer = () => {
        store.dispatch('sys/handleCloseDrawer')
      }

      /**
       * 弹窗返回上一级
       */
      const handleBackDrawer = () => {
        store.dispatch('sys/handleBackDrawer')
      }

      /**
       * 弹窗列表添加一个配置
       * @param {*} data
       */
      const handlePushDrawerList = (data) => {
        store.commit('sys/setOpenPageDrawerConfig', {
          row: toRaw(data.row),
          item: toRaw(data.item),
        })
      }

      /**
       * 刷新列表
       */
      const handleRefreshTable = () => {
        // 防止数据一直为true时不刷新
        store.commit('sys/setRefreshTable', false)
        nextTick(() => {
          store.commit('sys/setRefreshTable', true)
        })
      }

      /**
       * 刷新详情
       */
      const handleRefreshDrawerDetail = () => {
        pageDetailRef?.value?.handleRefreshDrawerDetail()
      }

      /**
       * 关左侧产品添加弹窗
       */
      const handleCloseAddProductDrawer = () => {
        store.dispatch('sys/handleCloseAddProductDrawer')
      }

      /**
       * 表单添加成功
       */
      const handleAddSuccess = () => {
        handleCloseAddProductDrawer()
      }
      /**
       * 表单编辑成功
       */
      const handleEditSuccess = () => {
        handleCloseAddProductDrawer()
      }

      // 改变tabs
      const handleChangeTab = (name) => {
        pageDetailRef.value?.handleChangeTab(name)
      }
      // 删除
      const handleDeleteSuccess = () => {
        handleCloseDrawer()
        handleRefreshTable()
        emit('delete-success')
      }

      const handleTabClick = (tab) => {
        if (!tabOpenBlankMode.value) return
        // const path = currentPagePath.value
        // const url = `${window.location.origin}/#${path}?tabname=${tab.paneName}`
        // SS.set('currentPageDrawerConfig', props.currentPageDrawerConfig)
        // window.open(url, '_blank')
      }
      watchEffect(() => {
        // 刷新页面 start
        if (refreshDrawerDetail?.value) {
          nextTick(() => {
            handleRefreshDrawerDetail()
            store.commit('sys/setRefreshDrawerDetail', 0) // 置空
          })
        }
        // 刷新页面 end
      })
      onBeforeMount(() => {})
      onBeforeUnmount(() => {
        // window.alert('JwtDetailDrawer 卸载')
      })
      return {
        pageDetailRef,
        slots,
        route,
        router,
        drawerConfig,
        userMenusAuthObj,
        currentPagePath,
        currentTabsInstance,
        openPageDrawerConfigList,
        handleHeaderAction,
        handleEditRowProp,
        handleClickRow,
        handleDesEditSuccess,
        handleCloseDrawer,
        handleBackDrawer,
        handleRefreshTable,
        handlePushDrawerList,
        handleAddSuccess,
        handleEditSuccess,
        handleFooterAction,
        handleRefreshDrawerDetail,
        handleDrawerAddSuccess,
        handleChangeTab,
        handleDeleteSuccess,
        handleTabClick,
      }
    },
  })
</script>

<style lang="scss" scoped></style>
